export interface IProgramType {
  id: number;
  name: string;
  active: boolean | null;
}

export class ProgramType implements IProgramType {
  id;
  name;
  active;

  constructor(config: IProgramType) {
    this.id = config.id;
    this.name = config.name;
    this.active = config.active;
  }
}
